var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"public-page-content"},[_c('h1',[_vm._v("FAQ")]),_c('FaqItemList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }